import libero_disegno from '../images/libertà disegno.svg';
import personal_engrave from '../images/personal engrave.svg';
import laser_precision from '../images/laser precision.svg'

export const intro_list=[
    {
        title: 'Incisioni personali',
        description: 'Incidi qualcosa di speciale. \nPorta un orologio, un braccialetto, un anello o quello che desideri incidere. \nPersonaliziamo qualsiasi oggetto.',
        cName: 'left',
        link_name: 'Incisione su misura',
        link: '/engrave',
        image: personal_engrave,
        alt: 'Watch, wristlace, ring',
    },

    {
        title: 'Precisione laser',
        description: 'Usando la marcatura laser, ogni disegno e scritta sarà ad alta risoluzione in qualsiasi dimensione. \nIncisioni di precisione ai micrometri.',
        cName: 'right',
        link_name: 'Incidi',
        link: '/engrave',
        image: laser_precision,
        alt: 'Laser accurancy',
    },

    {
        title: 'Libertà di disegno',
        description: 'Realiziamo per voi diesgni su misura in base alle vostre specifiche, con l\'uso di Photoshop ed Illustrator. \nInnumerevoli font tra i quali scegliere.',
        cName: 'left',
        link_name: 'Commissiona disegno',
        link: '/engrave',
        image: libero_disegno,
        alt: 'Gold',
    }
]